import { 
  ElButton, 
  ElAlert,
  ElLoading,
  ElMessage,
  ElMessageBox,
  ElContainer,
  ElAside,
  ElMain,
  ElMenu,
  ElMenuItem,
  ElBreadcrumb,
  ElBreadcrumbItem,
} from 'element-plus'
const components = [
  ElButton,
  ElAlert,
  ElContainer,
  ElAside,
  ElMain,
  ElMenu,
  ElMenuItem,
  ElBreadcrumb,
  ElBreadcrumbItem,
]
const plugins = [
  ElLoading,
  ElMessage,
  ElMessageBox
]
import lang from 'element-plus/lib/locale/lang/zh-cn'
import locale from 'element-plus/lib/locale'

export default (app) => {
  if(locale)locale.use(lang)
  components.forEach(component => {
    app.use(component)
  })
  plugins.forEach(plugin => {
    app.use(plugin)
  })
}


//  ElAlert,
//     ElAutocomplete,
//     ElBacktop,
//     ElButton,
//     ElButtonGroup,
//     ElCheckbox,
//     ElCheckboxButton,
//     ElCheckboxGroup,
//     ElDropdown,
//     ElDropdownItem,
//     ElDropdownMenu,
//     ElForm,
//     ElFormItem,
//     ElIcon,
//     ElInput,
//     ElInputNumber,
//     ElRadio,
//     ElRadioButton,
//     ElRadioGroup,
//     ElSelect,
//     ElOption,
//     ElOptionGroup,
//     ElSwitch,
//     ElUpload,
//     ElDrawer,
//     ElDialog,
      // ElLoading,
      // ElMessage,
      // ElMessageBox,
//     ElCollapseTransition,
//     ElCol,
//     ElRow,
//     ElTable,
//     ElTableColumn,
//     ElCollapse,
//     ElCollapseItem,
//     ElPopover,
//     ElCarousel,
//     ElCarouselItem,
//     ElTooltip,
//     ElTabs,
//     ElTabPane,
//     ElScrollbar
//} from 'element-plus'

// ElAlert,
//     ElAutocomplete,
//     ElBacktop,
//     ElButton,
//     ElButtonGroup,
//     ElCheckbox,
//     ElCheckboxButton,
//     ElCheckboxGroup,
//     ElDropdown,
//     ElDropdownItem,
//     ElDropdownMenu,
//     ElForm,
//     ElFormItem,
//     ElIcon,
//     ElInput,
//     ElRadio,
//     ElRadioButton,
//     ElRadioGroup,
//     ElSelect,
//     ElOption,
//     ElOptionGroup,
//     ElSwitch,
//     ElUpload,
//     ElDrawer,
//     ElDialog,
//     ElCol,
//     ElRow,
//     ElTable,
//     ElTableColumn,
//     ElPopover,
//     ElCarousel,
//     ElCarouselItem,
//     ElCollapse,
//     ElCollapseItem,
//     ElTooltip,
//     ElTabs,
//     ElTabPane,
//     ElInputNumber,
//     ElScrollbar
//]